import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { productAction, brandAction } from "@redux/modules";
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import moment from 'moment';

// react-icons
import { FaTrophy } from 'react-icons/fa';

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/zoom";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import "./styles.scss";

const Favourites = () => {
  const dispatch = useDispatch();
  const shopProductsRef = useRef(null);
  const brandProductsRef = useRef(null);
  const shopSwiperRef = useRef(null);
  const brandSwiperRef = useRef(null);

  const loginSettings = useSelector((store) => store.auth.loginSettings);
  const productFavouriteList = useSelector(
    (store) => store.product.productFavouriteList
  );
  const brandProductFavouriteList = useSelector(
    (store) => store.brand.brandProductFavouriteList
  );

  useEffect(() => {
    dispatch(productAction.getProductFavouriteList());
    dispatch(brandAction.getBrandProductFavouriteList());
  }, [dispatch]);

  // Dükkan ürünleri için Swiper
  useEffect(() => {
    if (productFavouriteList?.productDTOList?.length > 0 && shopProductsRef.current && !shopSwiperRef.current) {
      shopSwiperRef.current = new Swiper(shopProductsRef.current, {
        modules: [Navigation, Pagination],
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
          },
          576: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1200: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
        navigation: {
          nextEl: '.shop-products-slider .swiper-button-next',
          prevEl: '.shop-products-slider .swiper-button-prev',
        },
        spaceBetween: -8,
        pagination: {
          el: '.shop-products-slider .swiper-pagination',
          clickable: true,
        },
        watchSlidesProgress: true,
        watchOverflow: true,
      });
    }

    return () => {
      if (shopSwiperRef.current) {
        shopSwiperRef.current.destroy();
        shopSwiperRef.current = null;
      }
    };
  }, [productFavouriteList]);

  // Marka ürünleri için Swiper
  useEffect(() => {
    if (brandProductFavouriteList?.brandStyleDTOList?.length > 0 && brandProductsRef.current && !brandSwiperRef.current) {
      brandSwiperRef.current = new Swiper(brandProductsRef.current, {
        modules: [Navigation, Pagination],
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
          },
          576: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1200: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
        navigation: {
          nextEl: '.brand-products-slider .swiper-button-next',
          prevEl: '.brand-products-slider .swiper-button-prev',
        },
        spaceBetween: -8,
        pagination: {
          el: '.brand-products-slider .swiper-pagination',
          clickable: true,
        },
        watchSlidesProgress: true,
        watchOverflow: true,
      });
    }

    return () => {
      if (brandSwiperRef.current) {
        brandSwiperRef.current.destroy();
        brandSwiperRef.current = null;
      }
    };
  }, [brandProductFavouriteList]);

  return (
    <React.Fragment>
      <h2 className="mb-sm-6 mb-4">Favorilerim</h2>

      <h5 className="text-blue mb-4 mb-sm-4">Marka Ürünleri</h5>
      <div className="row g-sm-4">
        {brandProductFavouriteList && brandProductFavouriteList?.brandStyleDTOList?.length > 0 ? (
          <div className="swiper brand-products-slider" ref={brandProductsRef}>
            <div className="swiper-wrapper mb-sm-5 mb-4">
              {brandProductFavouriteList?.brandStyleDTOList.map((item) => (
                <div className="swiper-slide" key={item.id}>
                  <div className="h-auto p-3 favourite-products">
                    <div className="w-100 bg-white text-decoration-none shadow overflow-hidden rounded-3 h-100 d-flex flex-column">
                      {item.brandStyleContentDTOList &&
                      item.brandStyleContentDTOList.length > 0 &&
                      item.name ? (
                        <img
                          src={item.brandStyleContentDTOList[0].baseAddress}
                          alt={item.name}
                          className="img-contain w-100"
                          style={{ height: "200px", margin: "20px 0" }}
                        />
                      ) : (
                        <div style={{ height: "200px", background: "#000" }}>
                          <img
                            src={loginSettings?.logo}
                            alt=""
                            className="w-100 opacity-50"
                            style={{
                              width: "310px",
                              height: "200px",
                              objectFit: "scale-down",
                            }}
                          />
                        </div>
                      )}

                      <div className="p-sm-4 p-3 flex-grow-1 d-flex flex-column justify-content-between">
                        {item.stock && (
                          <span className="d-block small text-blue">
                            {item.stock} stok
                          </span>
                        )}

                        {item.name && (
                          <h5 className="fw-normal lh-base mb-2">{item.name}</h5>
                        )}

                        {item.score !== undefined && item.score !== null && (
                          <span className="d-block small text-blue mb-4">
                            {item.score} <FaTrophy />
                          </span>
                        )}

                        {item?.dateOrder && (
                          <span className="d-block small text-blue mb-4">
                            {moment(item.dateOrder, 'DD-MM-YYYY HH:mm').format('DD.MM.YYYY - HH:mm')}
                          </span>
                        )}

                        <Link
                          to={`/brand-product-detail/${item.brandSubCategoryId}/${item.id}`}
                          data-id={`${item.id}`}
                          data-count={
                            item.productCartCount ? item.productCartCount : "0"
                          }
                          className="btn btn-green text-white w-100 rounded-pill py-sm-3 py-2 px-sm-4 px-3 text-nowrap mt-auto add-to-cart-default"
                        >
                          <span>İncele</span>
                          <i className="fas fa-arrow-right ms-2 d-sm-inline-block d-none"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="swiper-pagination"></div>
            <div className="swiper-button-next">
              <i className="fas fa-chevron-right" style={{ fontSize: "2rem", color: `${loginSettings?.blue}` }}></i>
            </div>
            <div className="swiper-button-prev">
              <i className="fas fa-chevron-left" style={{ fontSize: "2rem", color: `${loginSettings?.blue}` }}></i>
            </div>
          </div>
        ) : (
          <div>Marka ürünleri favorilerinize herhangi bir ürün eklenmedi.</div>
        )}
      </div>

      <h5 className="text-blue mb-4 mb-sm-4 mt-5">Dükkan Ürünleri</h5>
      <div className="row g-sm-4">
        {productFavouriteList && productFavouriteList?.productDTOList?.length > 0 ? (
          <div className="swiper shop-products-slider" ref={shopProductsRef}>
            <div className="swiper-wrapper mb-sm-5 mb-4">
              {productFavouriteList &&
              productFavouriteList?.productDTOList?.length > 0 && (
                productFavouriteList?.productDTOList.map((item) => {
                  return (
                    <div className="h-auto p-3 favourite-products swiper-slide" key={item.id}>
                      <div className="w-100 bg-white text-decoration-none shadow overflow-hidden rounded-3 h-100 d-flex flex-column">
                        {item.productContentUrlList &&
                        item.productContentUrlList.length > 0 &&
                        item.name ? (
                          <img
                            src={item.productContentUrlList[0].baseAddress}
                            alt={item.name}
                            className="img-contain w-100"
                            style={{ height: "200px", margin: "20px 0" }}
                          />
                        ) : (
                          <div style={{ height: "200px", background: "#000" }}>
                            <img
                              src={loginSettings?.logo}
                              alt=""
                              className="w-100 opacity-50"
                              style={{
                                width: "310px",
                                height: "200px",
                                objectFit: "scale-down",
                              }}
                            />
                          </div>
                        )}

                        <div className="p-sm-4 p-3 flex-grow-1 d-flex flex-column justify-content-between">
                          {item.stock && (
                            <span className="d-block small text-blue">
                              {item.stock} stok
                            </span>
                          )}

                          {item.name && (
                            <h5 className="fw-normal lh-base mb-2">{item.name}</h5>
                          )}

                          {item.score !== undefined && item.score !== null && (
                            <span className="d-block small text-blue mb-4">
                              {item.score} <FaTrophy />
                            </span>
                          )}

                          {item?.dateOrder && (
                            <span className="d-block small text-blue mb-4">
                              {moment(item.dateOrder, 'DD-MM-YYYY HH:mm').format('DD.MM.YYYY - HH:mm')}
                            </span>
                          )}

                          <Link
                            to={`/shop/${item.id}`}
                            // onClick={(e) => addToCart(e, item.id)}
                            data-id={`${item.id}`}
                            data-count={
                              item.productCartCount ? item.productCartCount : "0"
                            }
                            className="btn btn-green text-white w-100 rounded-pill py-sm-3 py-2 px-sm-4 px-3 text-nowrap mt-auto add-to-cart-default"
                          >
                            <span>İncele</span>
                            <i className="fas fa-arrow-right ms-2 d-sm-inline-block d-none"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            <div className="swiper-pagination"></div>
            <div className="swiper-button-next">
              <i className="fas fa-chevron-right" style={{ fontSize: "2rem", color: `${loginSettings?.blue}` }}></i>
            </div>
            <div className="swiper-button-prev">
              <i className="fas fa-chevron-left" style={{ fontSize: "2rem", color: `${loginSettings?.blue}` }}></i>
            </div>
          </div>
        ) : (
          <div>Dükkan ürünleri favorilerinize herhangi bir ürün eklenmedi.</div>
        )}
      </div>

      
    </React.Fragment>
  );
};

export default Favourites;
